/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcmTopicRequest
 */
export interface FcmTopicRequest {
    /**
     * 
     * @type {string}
     * @memberof FcmTopicRequest
     */
    fcmToken: string;
}

/**
 * Check if a given object implements the FcmTopicRequest interface.
 */
export function instanceOfFcmTopicRequest(value: object): value is FcmTopicRequest {
    if (!('fcmToken' in value) || value['fcmToken'] === undefined) return false;
    return true;
}

export function FcmTopicRequestFromJSON(json: any): FcmTopicRequest {
    return FcmTopicRequestFromJSONTyped(json, false);
}

export function FcmTopicRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcmTopicRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fcmToken': json['fcm_token'],
    };
}

export function FcmTopicRequestToJSON(json: any): FcmTopicRequest {
    return FcmTopicRequestToJSONTyped(json, false);
}

export function FcmTopicRequestToJSONTyped(value?: FcmTopicRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fcm_token': value['fcmToken'],
    };
}
